// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// TODO: Add your Firebase project's configuration
const firebaseConfig = {
  apiKey: "AIzaSyCkEtUP9jw_J4M2tij6-96aXsgErLqR108",
  authDomain: "savemom-starter.firebaseapp.com",
  databaseURL: "https://savemom-starter-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "savemom-starter",
  storageBucket: "savemom-starter.firebasestorage.app",
  messagingSenderId: "732727949858",
  appId: "1:732727949858:web:7b27a98545080bf0fca87b",
  measurementId: "G-ZXTPCTMS9J"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);